<template>
  <div class="suggestArea">
    <ul class="suggestList">
      <li
        v-for="item in list"
        :key="item.id"
        class="suggestListItem"
        :class="{ grey: 'grey' === item.background, dense: dense, isPc: !isSp }"
        @mousedown="onClick(item)"
      >
        {{ item.name }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'SuggestList',
  props: {
    list: {
      type: Array,
      required: true,
    },
    dense: {
      type: Boolean,
      required: false,
      default: false,
    },
    isSpFlg: {
      type: Boolean,
      required: false,
      default: undefined,
    },
  },
  computed: {
    isSp() {
      if (typeof this.isSpFlg === 'boolean') return this.isSpFlg;
      return this.$isSp;
    },
  },
  methods: {
    onClick(item) {
      if (item.background !== 'grey') {
        this.$emit('onClick', item);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'css/contents/common/global';

.suggestArea {
  .suggestList {
    background: $color-background-primary-third-light;
    border: $border-sapuri-white-light;
    font-size: $text-size-caption1;
    max-height: 240px;
    overflow: scroll;
    -ms-overflow-style: none;

    .suggestListItem {
      padding: 12px;

      &.dense {
        padding: 8px 12px;
      }

      border-bottom: $border-sapuri-white-light;

      &:last-child {
        border-bottom: none;
      }

      &:hover {
        background: $color-background-secondry-light;
      }

      &.grey {
        padding: 6px 12px;
        background: $color-background-secondry-second-light;
        text-align: center;

        &:hover {
          background: $color-background-secondry-second-light;
        }
      }
    }
  }
}
</style>
